export const ROLES = {
	admin: "admin",
	oddscompiler: "oddscompiler",
	trader: "trader",
	analyst: "analyst",
	analyst_viewer: "analyst_viewer",
};

export const SCOPES = {
	canAudit: "can-audit",
	canEdit: "can-edit",
	canView: "can-view",
	canBet: "can-bet",
	canAnalyze: "can-analyze",
	canAdmin: "can-admin"
};

export const PERMISSIONS = {
	[ROLES.admin]: [SCOPES.canAdmin, SCOPES.canView, SCOPES.canBet, SCOPES.canEdit, SCOPES.canAudit, SCOPES.canAnalyze],
	[ROLES.trader]: [SCOPES.canBet, SCOPES.canView],

	[ROLES.analyst]: [SCOPES.canAnalyze, SCOPES.canView, SCOPES.canEdit],
	[ROLES.analyst_viewer]: [SCOPES.canAnalyze, SCOPES.canView],

	[ROLES.oddscompiler]: [SCOPES.canView],
};